import React from 'react';
import TabsComponent from '@modules/home/main/sub-modules-menu/tabsComponent/TabsComponent';
interface ReportsProps {
  sectionUIData: any;
  sectionRowsData: any;
  module: any;
  subModule: any;
}

const ReportsComponent = (props: ReportsProps): React.ReactElement => {
  const {sectionUIData, sectionRowsData, module, subModule} = props;

  return (
    <TabsComponent
      sectionUIData={sectionUIData}
      sectionRowsData={sectionRowsData}
      module={module}
      sub_module={subModule}
    />
  );
};

export default ReportsComponent;
